// src/config/plotConfigs/differentialCdsLeaderConfig.js
export const differentialCdsLeaderDefaults = {
  minread: 20,
  maxread: 150,
  ambig_check: false,
  email: false,
};

export const differentialCdsLeaderValidation = {
  minread: { required: true, min: 1, max: 1000, label: "Minimum read length" },
  maxread: { required: true, min: 1, max: 1000, label: "Maximum read length" },
  custom: (value, allSettings) => {
    if (allSettings.minread >= allSettings.maxread) {
      return "Min read length must be less than max read length";
    }
    return null;
  },
};

export const differentialCdsLeaderConfig = {
  sections: [
    {
      fields: [
        {
          id: "minread",
          label: "Minimum read length",
          type: "number",
          placeholder: "20",
          min: 1,
          max: 1000,
          tooltip:
            "The minimum read length to be displayed on the graph. Any reads below this length will be ignored.",
          width: 3,
        },
        {
          id: "maxread",
          label: "Maximum read length",
          type: "number",
          placeholder: "150",
          min: 1,
          max: 1000,
          tooltip:
            "The maximum read length to be displayed on the graph. Any reads above this length will be ignored.",
          width: 3,
        },
        {
          id: "ambig_check",
          label: "Allow ambiguously mapped reads",
          type: "checkbox",
          tooltip: "Include ambiguously mapped reads",
          width: 3,
        },
        {
          id: "email",
          label: "Email notification",
          type: "checkbox",
          tooltip: "Send email when analysis is complete",
          width: 3,
        },
      ],
    },
  ],
};
